import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import withProps from 'recompose/withProps'
import _ from 'lodash'
import {
  Axios,
  Segment,
  DataTable,
  Table,
  Text,
  Checkbox,
  Button,
} from 'component/base'
import { Custom } from 'component/pieces'

export const Find = withRouter(props => {
  const {
    mode,
    condition,
    onSelectChange,
    multiple,
    refresh,
    haiso_kanren_chushutsu_taishobi_kbn,
  } = props

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [selectedIds, setSelectedIds] = useState([])

  const BASE_URL = useMemo(
    () =>
      mode === 'kumiaiin'
        ? `/api/staff/haisha/haishashiharai/kumiaiin`
        : mode === 'tatanso'
        ? `/api/staff/haisha/haishashiharai/tatanso`
        : `/api/staff/haisha/haishashiharai/kumiaiin`,
    [mode]
  )

  useEffect(() => {
    callApi(condition)
    setSelectedIds([])
  }, [condition, refresh])

  const callApi = async condition => {
    setLoading(true)
    const { data, error } = await Axios.ajax.get(BASE_URL, {
      params: {
        ...condition,
      },
    })
    setLoading(false)
    if (error) return
    setData(data)
  }

  // aggregate haisha data to shiharai data(tokuisaki aggr)
  const aggr_data = useMemo(
    () =>
      _(data)
        .groupBy('torihikisaki_id')
        .map((rows, key) => {
          const row = rows[0] || {}
          const zei_rate = row && row.zei_rate ? row.zei_rate : 0

          return {
            ...row,
            torihikisaki_id: key,
            kanryo_date_from: _.orderBy(rows, ['kanryo_date'], ['asc'])[0]
              .kanryo_date,
            kanryo_date_to: _.orderBy(rows, ['kanryo_date'], ['desc'])[0]
              .kanryo_date,
            haisha_count: rows.length,
            shiharai_gaku: _.sumBy(rows, 'shiharai_gaku'),
            shiharai_zei_gaku:
              row.zei_keisan_kbn === 'seikyu_soto'
                ? Math.floor(
                    (_.sumBy(rows, 'unchin_shiharai_gaku') *
                      _.toNumber(zei_rate)) /
                      100
                  )
                : _.sumBy(rows, 'shiharai_zei_gaku'),
            shiharai_zeikomi_gaku:
              row.zei_keisan_kbn === 'seikyu_soto'
                ? _.sumBy(rows, 'shiharai_gaku') +
                  Math.floor(
                    (_.sumBy(rows, 'unchin_shiharai_gaku') *
                      _.toNumber(zei_rate)) /
                      100
                  )
                : _.sumBy(rows, 'shiharai_zeikomi_gaku'),
            haisha_id_list: _(rows)
              .filter(row => row.haisha_id)
              .map(row => row.haisha_id)
              .value(),
            seikyu_shiharai_meisai_id_list: _(rows)
              .filter(row => row.seikyu_shiharai_meisai_id)
              .map(row => row.seikyu_shiharai_meisai_id)
              .value(),
          }
        })
        .value(),
    [data]
  )

  useEffect(() => {
    onSelectChange(
      selectedIds,
      _.filter(aggr_data, row =>
        _.find(selectedIds, id => row.torihikisaki_id === id)
      )
    )
  }, [selectedIds])

  const handleAllSelect = () =>
    setSelectedIds(
      _(aggr_data)
        .map(row => row.torihikisaki_id)
        .value()
    )

  const handleAllDeSelect = () => setSelectedIds([])

  const handleChangeSelect = (selectedId, selected) => {
    setSelectedIds(selectedIds =>
      selected
        ? multiple
          ? _.union(selectedIds, [selectedId])
          : [selectedId]
        : _.filter(selectedIds, id => id !== selectedId)
    )
  }

  const TableRowWithProps = withProps(props => ({
    ...props,
    handleChangeSelect,
  }))(TableRow)

  const TableHeaderWithProps = useCallback(
    props => (
      <TableHeader
        {...props}
        haiso_kanren_chushutsu_taishobi_kbn={
          haiso_kanren_chushutsu_taishobi_kbn
        }
      />
    ),
    [haiso_kanren_chushutsu_taishobi_kbn]
  )

  return (
    <>
      <Segment basic loading={loading} style={{ padding: '0em' }}>
        <DataTable
          name='haisha-shiharai_shime-find'
          sortable
          filterable
          tableHeight='50vh'
          tableHeader={TableHeaderWithProps}
          tableRow={TableRowWithProps}
          data={aggr_data}
          topControl={
            <Button.Group>
              <Button content='全選択' onClick={handleAllSelect} />
              <Button content='全解除' onClick={handleAllDeSelect} />
            </Button.Group>
          }
          bottomControl={<></>}
          selectedIds={selectedIds}
        />
      </Segment>
    </>
  )
})

const TableHeader = props => {
  const {
    withOrder,
    handleSort,
    column,
    direction,
    haiso_kanren_chushutsu_taishobi_kbn,
  } = props

  return withOrder(
    <Table.Row>
      <Table.HeaderCell style={{ width: '3.0rem' }} content='#' />
      <Table.HeaderCell
        style={{ width: '15.0rem' }}
        sorted={column === 'haiso_center_name' ? direction : null}
        onClick={() => handleSort('haiso_center_name')}
        content='配送センター'
      />
      <Table.HeaderCell
        style={{ width: '15.0rem' }}
        sorted={column === 'unsoten_cd' ? direction : null}
        onClick={() => handleSort('unsoten_cd')}
        content='運送店コード'
      />
      <Table.HeaderCell
        style={{ width: '25.0rem' }}
        sorted={column === 'unsoten_name' ? direction : null}
        onClick={() => handleSort('unsoten_name')}
        content='運送店名'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'kanryo_date_from' ? direction : null}
        onClick={() => handleSort('kanryo_date_from')}
        content={haiso_kanren_chushutsu_taishobi_kbn !== 'nyukin_yotei' ? '完了日（最小）' : '入金予定日（最小）'}
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'kanryo_date_to' ? direction : null}
        onClick={() => handleSort('kanryo_date_to')}
        content={haiso_kanren_chushutsu_taishobi_kbn !== 'nyukin_yotei' ? '完了日（最大）' : '入金予定日（最大）'}
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'haisha_count' ? direction : null}
        onClick={() => handleSort('haisha_count')}
        content='配車票件数'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'zei_keisan_kbn' ? direction : null}
        onClick={() => handleSort('zei_keisan_kbn')}
        content='税計算区分'
      />
      <Table.HeaderCell
        style={{ width: '10.0rem' }}
        sorted={column === 'zei_rate' ? direction : null}
        onClick={() => handleSort('zei_rate')}
        content='消費税率'
      />
      <Table.HeaderCell
        style={{ width: '15.0rem' }}
        sorted={column === 'shiharai_gaku' ? direction : null}
        onClick={() => handleSort('shiharai_gaku')}
        content='税抜額計'
      />
      <Table.HeaderCell
        style={{ width: '15.0rem' }}
        sorted={column === 'shiharai_zei_gaku' ? direction : null}
        onClick={() => handleSort('shiharai_zei_gaku')}
        content='消費税額計'
      />
      <Table.HeaderCell
        style={{ width: '15.0rem' }}
        sorted={column === 'shiharai_zeikomi_gaku' ? direction : null}
        onClick={() => handleSort('shiharai_zeikomi_gaku')}
        content='支払額計'
      />
    </Table.Row>
  )
}

const TableRow = props => {
  const { withOrder, data, selectedIds, handleChangeSelect } = props || {}

  const {
    haiso_center_name,
    torihikisaki_id: id,
    unsoten_cd,
    unsoten_name,
    kanryo_date_from,
    kanryo_date_to,
    haisha_count,
    zei_keisan_kbn,
    zei_rate,
    shiharai_gaku,
    shiharai_zei_gaku,
    shiharai_zeikomi_gaku,
  } = data || {}

  const [isSelected, setIsSelected] = useState(
    selectedIds.indexOf(id) >= 0 ? true : false
  )

  const checkboxChange = (event, { value, checked }) => {
    event.stopPropagation()
    setIsSelected(checked)
    handleChangeSelect(value, checked)
  }

  return withOrder(
    <Table.Row
      positive={isSelected}
      onClick={() => {
        setIsSelected(state => !state)
        handleChangeSelect(id, !isSelected)
      }}
    >
      <Table.Cell
        style={{ width: '3.0rem' }}
        textAlign='center'
        content={
          <Checkbox checked={isSelected} onChange={checkboxChange} value={id} />
        }
      />
      <Table.Cell style={{ width: '15.0rem' }} content={haiso_center_name} />
      <Table.Cell style={{ width: '15.0rem' }} content={unsoten_cd} />
      <Table.Cell style={{ width: '25.0rem' }} content={unsoten_name} />
      <Table.Cell style={{ width: '10.0rem' }} content={kanryo_date_from} />
      <Table.Cell style={{ width: '10.0rem' }} content={kanryo_date_to} />
      <Table.Cell style={{ width: '10.0rem' }} content={haisha_count} />
      <Table.Cell
        style={{ width: '10.0rem' }}
        content={<Custom.Label.Zeikeisan value={zei_keisan_kbn} />}
      />
      <Table.Cell style={{ width: '10.0rem' }} content={zei_rate} />
      <Table.Cell
        style={{
          width: '15.0rem',
          textAlign: 'right',
        }}
        content={<Text.Comma content={shiharai_gaku} />}
      />
      <Table.Cell
        style={{
          width: '15.0rem',
          textAlign: 'right',
        }}
        content={<Text.Comma content={shiharai_zei_gaku} />}
      />
      <Table.Cell
        style={{
          width: '15.0rem',
          textAlign: 'right',
        }}
        content={<Text.Comma content={shiharai_zeikomi_gaku} />}
      />
    </Table.Row>
  )
}